export const THIRD_PARTY_SHARE_TYPES = {
  CHANNEL: 'CHANNEL',
  USER: 'USER'
};